// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","title":"title-2aEhR","button":"button-1WLpD","location":"location-3YCUy","from":"from-2OXJ5","input":"input-2vRQT","to":"to-1kGp5"};